import { EPartyType } from 'modules/common/types/partyTypes';

export interface IProps {
  partyId: number;
  partyType: EPartyType;
  type: ESuggestionType;
  title: string;
  description: string;
}

export enum ESuggestionType {
  STORED = 'STORED',
  PERSON = 'PERSON',
  GROUP = 'GROUP',
}
